(() => {
  "use strict";

  if (customElements.get("feature-stack")) {
    return;
  }

  class FeatureStack extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.titleButtons = [];
      this.stackItems = [];
    }

    connectedCallback() {
      this.titleButtons = Array.from(
        this.querySelectorAll("[data-feature-stack-titles] [data-index]")
      );
      this.stackItems = Array.from(
        this.querySelectorAll("[data-feature-stack-images] [data-index]")
      );

      this.bindTitleEvents();
      this.initSwiper();
      this.setActive(0, false);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    bindTitleEvents() {
      const canHover = window.matchMedia("(hover: hover)").matches;

      this.titleButtons.forEach((button) => {
        const index = Number(button.dataset.index);

        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.setActive(index, true);
        });

        if (canHover) {
          button.addEventListener("mouseenter", () => {
            this.setActive(index, true);
          });
        }
      });
    }

    initSwiper() {
      const swiperElement = this.querySelector("[data-feature-stack-swiper]");
      if (!swiperElement || typeof Swiper === "undefined") {
        return;
      }

      const prevEl = swiperElement.querySelector(".swiper-button-prev");
      const nextEl = swiperElement.querySelector(".swiper-button-next");

      this.swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        speed: 450,
        navigation: {
          prevEl,
          nextEl,
        },
        observer: true,
        observeParents: true,
        on: {
          slideChange: () => {
            this.setActive(this.swiper.activeIndex, false);
          },
        },
      });
    }

    setActive(index, syncSwiper = true) {
      this.titleButtons.forEach((button) => {
        button.classList.toggle(
          "is-active",
          Number(button.dataset.index) === index
        );
      });

      this.stackItems.forEach((item) => {
        item.classList.toggle("is-active", Number(item.dataset.index) === index);
      });

      const activeButton = this.titleButtons.find(
        (button) => Number(button.dataset.index) === index
      );
      if (activeButton) {
        activeButton.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }

      if (syncSwiper && this.swiper && this.swiper.activeIndex !== index) {
        this.swiper.slideTo(index);
      }
    }
  }

  customElements.define("feature-stack", FeatureStack);
})();